module.exports = __webpack_public_path__ + "static/media/icon-code-of-practice-accepted.63cc335a.svg";